import { render, staticRenderFns } from "./TicketSetting.vue?vue&type=template&id=f5af7d92&scoped=true&"
import script from "./TicketSetting.vue?vue&type=script&lang=js&"
export * from "./TicketSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5af7d92",
  null
  
)

export default component.exports